import axios from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { URL_LIST_ALL } from "../configs/api";
import PostsList from "./PostList";
import AkkhorLayout from "../layout/akkhor";
import { useParams } from "react-router-dom";
import Calendar from "./Calendar";


export default function ChiTietTin() {
  const { user } = useSelector((state) => state.auth);
  const { id } = useParams();
  const info = user && user.data ? user.data : null;
  const [listnews, setListNews] = useState(null)

  useEffect(() => {
    axios.get(URL_LIST_ALL + "news?limit=10000&forusers=" + user.data.code, user.config)
      .then(async (res) => {
        if (res.data.status === "success") {
          setListNews(res.data.data)
        } else console.log(res.data.message);
      })
      .catch((err) => console.log(err));
  }, [user]);// eslint-disable-line

  return (
    <AkkhorLayout idrole="dashboard" class_name="home-dashboard-content">
      <div className="row home-dashboad">
        {info &&
          <div className="container-fluid pb-0 form-info">
            <div className="row">
              <div className="col-12 col-md-8 list-post-content">
                <PostsList postId={id} />
              </div>
              <div className="col-12 col-md-4 pl-0 d-none d-sm-block">
                <div className="w-100 d-flex justify-content-center">
                  <Calendar />
                </div>
                <div className="w-100 d-flex justify-content-center">
                  <div className=" bg-white-border pd-15">
                    <h3 className="w-100 text-center">Quy trình nội bộ</h3>
                    <ul className="dashboard-list-new">
                      {listnews && listnews.map((item, i) => {
                        return (
                          <li key={i}>
                            <a href={"/quy-trinh-noi-bo/" + item.id}><i className="	fas fa-angle-double-right"></i> {item.title}</a>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </AkkhorLayout>)
}